import React, { useContext, useState } from "react";

import { ChecklistContext } from "../../context";
import { PreviewQuestion } from "./PreviewQuestion";
import {
  ContentArea,
  DynamicIsland,
  HomeIndicator,
  NavTitle,
  NavHeader,
  NavRightIcons,
  PhoneFrame,
  PhoneFramePopover,
  PhoneScreen,
  PowerButton,
  StatusBar,
  StatusBarIcons,
  StatusBarTime,
  VolumeButton,
  NavHeaderIcons,
  NavTriggers,
  NavTriggersText,
} from "./styles";
import { Battery50, SignalWifi0Bar, SignalCellular4Bar } from "@mui/icons-material";
import { ArrowLeft, Timer1, HambergerMenu, ClipboardText } from "iconsax-react";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

interface PreviewPopoverProps {
  open: boolean;
  onClose: () => void;
  anchorEl?: HTMLElement | null;
}

export const PreviewPopover = ({ open, onClose, anchorEl }: PreviewPopoverProps) => {
  const { checklist } = useContext(ChecklistContext);
  const [answers, setAnswers] = useState<Record<string, string>>({});

  const { t: translate } = useTranslation();

  const handleAnswerChange = (questionKey: string, value: string) => {
    setAnswers((prev) => ({
      ...prev,
      [questionKey]: value,
    }));
  };

  if (!checklist || !checklist.questions || checklist.questions.length === 0) {
    return null;
  }

  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <PhoneFramePopover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <PhoneFrame>
        <VolumeButton position="top" />
        <VolumeButton position="bottom" />
        <PowerButton />

        <PhoneScreen>
          <DynamicIsland />

          <StatusBar>
            <StatusBarTime>{currentTime}</StatusBarTime>
            <StatusBarIcons>
              <SignalWifi0Bar fontSize="small" />
              <SignalCellular4Bar fontSize="small" />
              <Battery50 fontSize="small" />
            </StatusBarIcons>
          </StatusBar>

          <NavHeader>
            <NavHeaderIcons>
              <ArrowLeft size={20} color={colors.gray600} />

              <NavRightIcons>
                <Timer1 size={20} color={colors.gray600} />
                <HambergerMenu size={20} color={colors.gray600} />
              </NavRightIcons>
            </NavHeaderIcons>

            <NavTitle>12345 - Carlos Ferri</NavTitle>
          </NavHeader>

          <NavTriggers>
            <ClipboardText size={20} color={colors.gray600} />
            <NavTriggersText>{translate("beforeAcceptTask")}</NavTriggersText>
          </NavTriggers>

          <ContentArea>
            {checklist.questions.map((question) => (
              <PreviewQuestion
                key={question.id || question.temporaryId}
                question={question}
                answers={answers}
                onAnswerChange={handleAnswerChange}
              />
            ))}
          </ContentArea>

          <HomeIndicator />
        </PhoneScreen>
      </PhoneFrame>
    </PhoneFramePopover>
  );
};
